<div fxLayout="column" fxLayoutGap="20px">
  <app-page-header
    (tabsChangeEvent)="changeTabs($event)"
    [selectedTab]="getInitialTab()"
    [isTabbed]="true"
    [section]="'Notification Templates'"
    [tabs]="tabs"
    [title]="'Setup your custom communications'"
    description="Select a template to edit by clicking on its name. Activate a template by clicking on the toggle"
  ></app-page-header>

  <mat-sidenav-container class="sidenav-container  body-1-regular-2">
  <!--  left Side Nav-->

  <mat-sidenav #leftSideNav mode="side" opened position="start" class="sidenav-left template-builder-sidenav-left"
               [fixedInViewport]="false" [fixedTopGap]="0"
               [fixedBottomGap]="0">
    <div class="sidenav-left-content template-left-content" fxLayout="column" fxFlex="300px" fxLayoutGap="15px">
      <div [ngSwitch]="isTemplateSelected" fxLayout="column" fxLayoutGap="20px">
        <ng-container *ngSwitchCase="false">
          <div fxLayout="row" class="full-width" fxLayoutAlign="start center" fxLayoutGap="20px">
            <div fxLayout="column" fxLayoutGap="10px">
              <div class="heading-bold">Retailer Communication</div>
              <div fxFlexOffset="0px" *ngFor="let template of retailTemplates" fxLayout="row"
                   fxLayoutGap="10px" fxLayoutAlign="start center">
                <mat-slide-toggle class="template-slide-toggle" [disabled]="loader.loading$ | async"
                                  [checked]="template.notificationEnabled"
                                  (change)="changeNotificationEnabled($event, template)"
                                  color="primary"></mat-slide-toggle>
                <span  class="heading-default btn-cursor" (click)="selectTemplate(template)"> {{template.templateName}}</span>
              </div>
            </div>
          </div>
          <div fxLayout="row" class="full-width" fxLayoutGap="20px">
            <div fxLayout="column" fxLayoutGap="10px">
              <div class="heading-bold">System Notifications</div>
              <div fxFlexOffset="0px" *ngFor="let template of systemTemplates" fxLayout="row"
                   fxLayoutGap="10px" fxLayoutAlign="start center">
                <mat-slide-toggle class="template-slide-toggle" checked="true" disabled
                                  (change)="changeNotificationEnabled($event, template)"
                                  color="primary"></mat-slide-toggle>
                <span  class="heading-default btn-cursor" (click)="selectTemplate(template)"> {{template.templateName}}</span>
              </div>
            </div>
          </div>

          <div fxLayout="row" class="full-width" fxLayoutGap="20px">
            <div fxLayout="column" fxLayoutGap="10px">
              <div class="heading-bold">Internal Communication</div>
              <div fxFlexOffset="0px" *ngFor="let template of internalTemplates" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
                <mat-slide-toggle class="template-slide-toggle" [disabled]="loader.loading$ | async"
                                  [checked]="template.notificationEnabled"
                                  (change)="changeNotificationEnabled($event, template)"
                                  color="primary"></mat-slide-toggle>
                <span  class="heading-default btn-cursor" (click)="selectTemplate(template)"> {{template.templateName}}</span>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="true">
          <div fxLayout="row">
              <span class="currently-selected-template-icon" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
                <mat-icon class="material-symbols-outlined">edit_notifications</mat-icon>
                <span  class="heading-default"> {{selectedTemplate!.templateName}}</span>
              </span>
          </div>

          <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="end center">
            <button (click)="templateDesignerComponent.clearCurrentSelectedTemplate()"
                    [disabled]="selectedTemplate == null"
                    class="button-action-cancel" mat-flat-button>
              <div class="button-text">Back</div>
            </button>
            <button (click)="templateDesignerComponent.saveAndExportHtml()"
                    [disabled]="selectedTemplate == null || missingDynamicVars.length > 0"
                    class="button-action" mat-flat-button>
              <div class="button-text">Update</div>
            </button>
          </div>

          <div fxLayout = "row">
            Use the editor to customise this notification’s content and layout.
          </div>

          <div fxLayout="row">
            <div fxLayout="column" fxLayoutGap="10px">
              <div class="body-1-default">Custom reply to address</div>
              <mat-form-field appearance="outline" class="custom-text-field" style="width: 100%;">
                <input [(ngModel)]="selectedTemplate!.replyToAddress" matInput type="text"/>
                <mat-icon matSuffix class="template-editor-reply-to-icon">alternate_email</mat-icon>
              </mat-form-field>
              <div>This is the email address that will appear as the reply-to when recipients respond to the notification.</div>
            </div>
          </div>

          <div fxLayout="row" class="full-width">
            <div fxLayout="column" fxLayoutGap="12px">
              <div class="body-1-default">Dynamic Values</div>
              <div>
                This template includes dynamic values. These act as placeholders that will be filled with real data
                when the notification is sent — for example, the contact's name or the approval date. You can insert
                and manage these values using merge tags in the content editor.
              </div>

              <div *ngFor="let tag of selectedTemplate!.mergeTags">
                <div class="template-builder-dynamic-value-chip"
                  [ngClass]="missingDynamicVars.includes(tag[Object.keys(tag)[0]].name) ? 'warn-chip' : 'disabled-chip'"
                  fxLayout="row"
                  fxLayoutAlign="start center"
                  fxLayoutGap="5px">

                  <mat-icon class="template-builder-dynamic-value-icon">
                    {{ missingDynamicVars.includes(tag[Object.keys(tag)[0]].name) ? 'error' : 'check' }}
                  </mat-icon>

                  <span class="body-1-regular">
                    {{ utils.camelCaseToWords(Object.keys(tag)[0]) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

      </div>
    </div>
  </mat-sidenav>

  <!--  Main Content-->
  <mat-sidenav-content cdkScrollable class="sidenav-main-content">
    <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">

      <!--      Main content area-->
      <div class="content-padding" fxLayout="row" fxLayoutAlign="space-between center">
        <app-email-template-designer #templateDesignerComponent
                                     style="width: 100%"
                                     [offeringUuid]="offering!.uuid!"
                                     [selectedTemplate]="this.selectedTemplate!"
                                     (selectedTemplateChange)="changeSelectedTemplate($event)"
                                     (saveTemplate)="handleSaveTemplateResult($event)"
                                     (missingRequiredMergeTags)="handleMissingMergeTags($event)"
                                     [hideActionButtons]="true">
        </app-email-template-designer>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
</div>
